import React, { ReactElement } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Icon } from '@daedalus/atlas/Icon';
import { Link } from '@daedalus/atlas/Link';
import { Price } from '@daedalus/atlas/Price';
import { Text } from '@daedalus/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { OfferAlertVariant } from './constants';
import { offerAlertMessages, variantTranslations } from './offerAlertMessages';
type PropsTypes = {
  variant: OfferAlertVariant;
  onClick: () => void;
  price?: number;
  currency?: string;
  penalty?: ReactElement;
};
enum ColorType {
  Success = 'Success',
  Warning = 'Warning',
}
const AlertWrapper = /*#__PURE__*/styled('div')({
  name: "AlertWrapper",
  class: "a1kwclem",
  propsAsIs: false
});
const _exp9 = /*#__PURE__*/() => Price;
const AmountPrice = /*#__PURE__*/styled(_exp9())({
  name: "AmountPrice",
  class: "a8a3rbq",
  propsAsIs: true
});
const _exp13 = /*#__PURE__*/() => Link;
const WhyLink = /*#__PURE__*/styled(_exp13())({
  name: "WhyLink",
  class: "w1tn7ive",
  propsAsIs: true
});
export const VariantComponent = ({
  variant,
  onClick,
  price,
  currency,
  penalty
}: PropsTypes) => {
  const {
    id,
    defaultMessage
  } = variantTranslations[variant];
  const colorVariant = variant === OfferAlertVariant.PriceDrop ? ColorType.Success : ColorType.Warning;
  return <AlertWrapper className={cx(`--variant-${colorVariant}`)} onClick={onClick}>
      <Icon name="Alert" />
      <div>
        <FormattedMessageWrapper {...{
        id,
        defaultMessage
      }} values={{
        price: price && <AmountPrice value={price} currency={currency} className={cx(`--variant-${colorVariant}`)} isAbbreviated noStyle />,
        penalty: <Text tag="span" colorPath="content.warning.c950" variant="labelS">
                {penalty}
              </Text>
      }} />
        <WhyLink className={cx(`--variant-${colorVariant}`)} onClick={onClick}>
          <FormattedMessageWrapper {...offerAlertMessages.why} />
        </WhyLink>
      </div>
    </AlertWrapper>;
};

require("./VariantComponent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./VariantComponent.tsx");